import React from 'react';
export function PersonalTraining() {
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-353">
      <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-354">
        Personal Training
      </h1>
      <p className="text-xl text-gray-600" data-id="element-355">Program Content Coming Soon</p>
    </div>;
}